import gql from 'graphql-tag';

import { PREVIEW_CREDIT_FRAGMENT } from './credit';

export const DETAILED_TRANSACTION_FRAGMENT = gql`
    fragment DetailedTransactionFragment on Transaction {
        _id
        basketId
        basket {
            type
        }
        createdAt
        paymentMethods {
            _id
            amountUsed
            explanation
            name
            paymentMethodName
            provider
            providerTransactionId
            status
            type
        }
        priceHT
        productId
        productName
        refundReason
        siteId
        siteName
        microstoreColumnId
        microstoreColumnName
        newState
        mealPlan {
            discountRatio
        }
        stateHistory {
            state
            createdAt
            createdBy
        }
        tva
        userId
        userFullName
        nayaxMDBCode
    }
`;

export const PREVIEW_TRANSACTION_FRAGMENT = gql`
    fragment PreviewTransactionFragment on Transaction {
        _id
        basketId
        basket {
            type
        }
        createdAt
        paymentMethods {
            _id
            paymentMethodName
            provider
        }
        priceHT
        productId
        productName
        siteId
        siteName
        microstoreColumnId
        microstoreColumnName
        newState
        tva
        updatedAt
        userFullName
    }
`;

export const TRANSACTION_PAYMENT_FRAGMENT = gql`
    fragment TransactionPaymentFragment on TransactionPayment {
        _id
        paymentMethod {
            _id
            amountUsed
            explanation
            name
            paymentMethodName
            provider
            providerTransactionId
            status
        }
        transaction {
            _id
            createdAt
            productName
            siteId
            siteName
            userId
            userFullName
        }
    }
`;

export const SAVED_PAYMENT_METHOD_FRAGMENT = gql`
    fragment SavedPaymentMethodFragment on SavedPaymentMethod {
        _id
        provider
        paymentType
        label
        brand
        expiration
        isDefault
        retries
        archivedAt
        createdAt
        user {
            _id
            profile {
                fullname
            }
        }
    }
`;

export const PAYMENT_INSTRUMENT_FRAGMENT = gql`
    fragment PaymentInstrumentFragment on PaymentInstrument {
        _id
        kind
        savedPaymentMethod {
            ...SavedPaymentMethodFragment
        }
        credit {
            ...PreviewCreditFragment
        }
        organizationCard {
            _id
            state
            userId
            organization {
                _id
                name
            }
        }
        subvention {
            _id
            name
        }
        ritual {
            _id
            name
        }
        mealPlanDefinition {
            _id
            name
        }
    }
    ${SAVED_PAYMENT_METHOD_FRAGMENT}
    ${PREVIEW_CREDIT_FRAGMENT}
`;
